import { Icon } from "@iconify/react";
import React from "react";

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        Life care diagnostics center,

        
        <br />
        Ejipura Main Rd, Ejipura,
        <br />
        Bengaluru, Karnataka 560047, India
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        +91 9620111265
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        medayus.info@gmail.com
      </li>
    </ul>
  );
}
